import React, { useEffect, useState, useRef } from 'react';
import CountUp from 'react-countup';
import { RefreshCwIcon } from 'lucide-react';
import { statsData } from '../utils/constants';
const Stats = ({
  language = 'en'
}) => {
  const statsRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currencyMode, setCurrencyMode] = useState({});
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (statsRef.current) {
      observer.observe(statsRef.current);
    }
    return () => {
      if (statsRef.current) {
        observer.disconnect();
      }
    };
  }, []);
  const toggleCurrency = statId => {
    setCurrencyMode(prev => ({
      ...prev,
      [statId]: !prev[statId]
    }));
  };
  const translations = {
    en: {
      myNumbers: 'My Numbers',
      scholarship: 'Northeastern: Scholarship',
      toggleCurrency: 'Toggle currency',
      achievements: 'Achievements'
    },
    vi: {
      myNumbers: 'Thành Tích Của Tôi',
      scholarship: 'Học bổng Northeastern',
      toggleCurrency: 'Chuyển đổi tiền tệ',
      achievements: 'Thành tựu'
    }
  };
  const t = translations[language];
  // Add Northeastern scholarship stat
  const northeasternScholarship = {
    id: 'northeastern-scholarship',
    label: t.scholarship,
    value: 364,
    suffix: 'K USD',
    alternateValue: 9.6,
    alternateSuffix: 'B VND',
    hasCurrencyToggle: true,
    duration: 5.5
  };
  return <section className="w-full py-16 bg-background" data-id="element-446">
      <div className="container mx-auto px-4" data-id="element-447">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-12 fade-in" data-id="element-448">
          {t.myNumbers} <span className="gradient-text" data-id="element-449">{t.achievements}</span>
        </h2>
        <div ref={statsRef} className="space-y-12" data-id="element-450">
          {statsData.map(section => <div key={section.id} className="mb-12" data-id="element-451">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-452">
                {/* Add Northeastern scholarship as first stat */}
                <div className="bg-secondary rounded-2xl p-6 text-center card-glow transform transition-all duration-500 hover:scale-105" style={{
              animationDelay: `0s`
            }} data-id="element-453">
                  <h3 className="text-4xl font-display font-bold mb-2 stat-number flex items-center justify-center gap-2" data-id="element-454">
                    {isVisible && <>
                        {currencyMode[northeasternScholarship.id] ? <CountUp end={northeasternScholarship.alternateValue} duration={northeasternScholarship.duration || 6} decimals={northeasternScholarship.alternateValue < 100 ? 1 : 0} separator="," useEasing={true} data-id="element-455" /> : <CountUp end={northeasternScholarship.value} duration={northeasternScholarship.duration || 6} decimals={northeasternScholarship.value % 1 !== 0 ? 1 : 0} separator="," useEasing={true} data-id="element-456" />}
                      </>}
                    {!isVisible && '0'}
                    {currencyMode[northeasternScholarship.id] ? <span data-id="element-457">{northeasternScholarship.alternateSuffix}</span> : <span data-id="element-458">{northeasternScholarship.suffix}</span>}
                    {northeasternScholarship.hasCurrencyToggle && <button onClick={() => toggleCurrency(northeasternScholarship.id)} className="ml-2 p-1 rounded-full bg-background text-accent-cyan hover:bg-accent-cyan/20 transition-colors" title={t.toggleCurrency} data-id="element-459">
                        <RefreshCwIcon size={16} className="animate-spin-slow" data-id="element-460" />
                      </button>}
                  </h3>
                  <p className="text-muted text-lg" data-id="element-461">
                    {northeasternScholarship.label}
                  </p>
                </div>
                {/* Render all stats except GPA */}
                {section.stats.filter(stat => stat.id !== 'gpa').map((stat, index) => <div key={stat.id} className="bg-secondary rounded-2xl p-6 text-center card-glow transform transition-all duration-500 hover:scale-105" style={{
              animationDelay: `${index * 0.1}s`
            }} data-id="element-462">
                      <h3 className="text-4xl font-display font-bold mb-2 stat-number flex items-center justify-center gap-2" data-id="element-463">
                        {stat.prefix && <span data-id="element-464">{stat.prefix}</span>}
                        {isVisible && <>
                            {stat.hasCurrencyToggle && currencyMode[stat.id] ? <CountUp end={stat.alternateValue} duration={stat.duration || 6} decimals={stat.alternateValue < 100 ? 1 : 0} separator="," useEasing={true} data-id="element-465" /> : <CountUp end={stat.value} duration={stat.duration || 6} decimals={stat.value % 1 !== 0 ? 1 : 0} separator="," useEasing={true} data-id="element-466" />}
                          </>}
                        {!isVisible && '0'}
                        {stat.hasCurrencyToggle && currencyMode[stat.id] ? <span data-id="element-467">{stat.alternateSuffix}</span> : <span data-id="element-468">{stat.suffix}</span>}
                        {stat.hasCurrencyToggle && <button onClick={() => toggleCurrency(stat.id)} className="ml-2 p-1 rounded-full bg-background text-accent-cyan hover:bg-accent-cyan/20 transition-colors" title={t.toggleCurrency} data-id="element-469">
                            <RefreshCwIcon size={16} className="animate-spin-slow" data-id="element-470" />
                          </button>}
                      </h3>
                      <p className="text-muted text-lg" data-id="element-471">
                        {language === 'en' ? stat.label : stat.labelVi || stat.label}
                      </p>
                    </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Stats;